import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Button } from "reactstrap";
import CustomForm from "../../../custom/Forms/CustomForm";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import TextInput from "../../../custom/components/Text-Input/TextInput";
import TextAreaInput from "../../../custom/components/TextArea-Input/TextAreaInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, basicFormData } from "./UserFile";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../../custom/components/Asterisks/Asterisks";
import { validate } from "../../../custom/validations/Validate";
import {
  dropdownData,
  getRecords,
  saveRecords,
  uploadFile,
} from "../../../services/api.service";
import { toast } from "react-toastify";
import { imageURL } from "../../../services/api.service";
import CustomError from "../../../custom/components/Errors/CustomError";
import {
  isAlphabet,
  isEmail,
  isPassword,
  isPhoneNumber,
  minLength,
} from "../../../custom/validations/Ruls";

const UserCreate = () => {
  const userType = [
    { label: "Bermad User", value: 1 },
    { label: "Subcontractor", value: 2 },
    { label: "Customer", value: 3 },
  ];
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  const [formErrors, setFormErrors] = useState({});
  const [fetchedData, setFetchedData] = useState(null);
  // user types
  const [userTypeSelectOptions] = useState(userType);
  const [selectedUserType, setSelectedUserType] = useState(null);
  // role
  const [roleSelectOptions, setRoleSelectOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [isOrignalPassword, setIsOrignalPassword] = useState([]);
  const [isMultiPasswordShown, setIsMultiPasswordShown] = useState([]);
  const [companySelectOptions, setCompanySelectOptions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    if (id) {
      setIsPasswordShown(true);
      getEditData(id);
    } else {
      getRoleData();
    }
    // if (selectedUserType) {
    //   getCompanyData();
    // }
  }, [id]);

  useEffect(() => {
    if (selectedUserType) {
      getCompanyData();
    }
  }, [id, selectedUserType?.value]);

  useEffect(() => {
    if (fetchedData) {
      let data = fetchedData;
      setFormData((prevState) => ({
        ...prevState,
        inputData: {
          ...prevState.inputData,
          ...data,
        },
      }));
    }
  }, [fetchedData]);

  const getEditData = async (id) => {
    try {
      let payload = {
        modelName: "user_masters",
        moduleWhereCondition: {
          is_active: true,
        },
        relations: [
          {
            module: "user_masters",
            moduleAs: "subcontractor",
            fduleWhereConditionRequired: true,
          },
          {
            module: "user_documents",
            moduleAs: "user_documents",
            isModuleWhereConditionRequired: true,
          },
        ],
      };
      if (id) {
        payload.whereCondition = { id: id };
      }
      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        const matchRecords = userType.filter(
          (user) => user.value == data?.user_type
        );
        setIsOrignalPassword(
          data?.subcontractor.map((item) => item?.password || null)
        );
        const passwordStates = data.subcontractor.map(() => true);
        setIsMultiPasswordShown(passwordStates);
        setSelectedUserType(matchRecords[0]);
        getRoleData(data?.role_id);
        getCompanyData(data?.company_id);
        setFetchedData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const getRoleData = async (roleId) => {
    try {
      let payload = {
        modelName: "role_masters",
        whereCondition: {
          is_active: true,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "role_name"
        );
        if (id) {
          dropdownResponseData[0].options.forEach((element) => {
            if (element.value == roleId) {
              setSelectedRole(element);
            }
          });
        }
        setRoleSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getCompanyData = async (companyId) => {
    try {
      let payload = {
        modelName: "company_masters",

        relations: [
          {
            module: "company_documents",
            moduleAs: "documents",
          },
        ],
      };

      if (selectedUserType?.value !== 1) {
        payload.whereCondition = {
          type: selectedUserType?.value === 2 ? 1 : 2,
        };
      }

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        if (selectedUserType && selectedUserType?.value === 1) {
          // bermad user
          responseData.data = responseData.data?.filter(
            (data) => data?.id == 1
          );
        } else {
          responseData.data = responseData?.data?.filter(
            (data) => data?.id != 1
          );
        }
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "company_name"
        );

        if (id) {
          dropdownResponseData[0].options.forEach((element) => {
            if (element.value == companyId) {
              setSelectedCompany(element);
            }
          });
        }

        setCompanySelectOptions(dropdownResponseData);
        if (selectedUserType && selectedUserType?.value === 1) {
          const firstCompany = dropdownResponseData?.[0]?.options?.[0];
          if (firstCompany) {
            setSelectedCompany(firstCompany);
            setFormData((prevState) => ({
              ...prevState,
              inputData: {
                ...prevState.inputData,
                company_id: firstCompany?.value,
              },
            }));
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleUserTypeSelect = (options) => {
    setSelectedCompany(null);
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      user_type: selectedValue,
    });

    setSelectedUserType(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      user_type: fieldError?.user_type || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        user_type: selectedValue,
        company_id: null,
      },
    }));
  };

  const handleRoleSelect = (options) => {
  const selectedValue = options ? options.value : "";
  const fieldError = validate(validationType, {
    role_id: selectedValue,
  });

  setSelectedRole(options);
  setFormErrors((prevErrors) => ({
    ...prevErrors,
    role_id: fieldError?.role_id || "",
  }));

  setFormData((prevState) => ({
    ...prevState,
    inputData: {
      ...prevState.inputData,
      role_id: selectedValue,
    },
  }));
};

  const handleCompanySelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      company_id: selectedValue,
    });

    setSelectedCompany(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      company_id: fieldError?.company_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        company_id: selectedValue,
      },
    }));
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "password") {
      setIsPasswordShown(false);
    }

    setFormErrors((prevErrors) => {
      if ((name === "alt_mobile_number" || name === "gst_no") && value === "") {
        const { [name]: _, ...updatedErrors } = prevErrors;
        return updatedErrors;
      }

      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
            ? null
            : value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const validationErrors = validate(validationType, formData.inputData);
      if (!formData?.inputData?.alt_mobile_number) {
        delete validationErrors.alt_mobile_number;
      }
      if (!formData?.inputData?.gst_no) {
        delete validationErrors.gst_no;
      }
      // Additional validation for `user_documents`
      const additionalErrors = {};
      formData?.inputData?.user_documents?.forEach((row, index) => {
        if (row.is_active) {
          ["document", "file"].forEach((field) => {
            if (!row[field]?.toString().trim()) {
              additionalErrors.user_documents = {
                ...additionalErrors.user_documents,
                [index]: {
                  ...additionalErrors.user_documents?.[index],
                  [field]: `${field
                    .replace(/_/g, " ")
                    ?.replace(/\b\w/g, (char) =>
                      char?.toUpperCase()
                    )} is required`,
                },
              };
            }
            if (field === "document" && row[field]) {
              const alphabetError = isAlphabet(row[field], "document");
              if (alphabetError) {
                additionalErrors.user_documents = {
                  ...additionalErrors.user_documents,
                  [index]: {
                    ...additionalErrors.user_documents?.[index],
                    document: alphabetError,
                  },
                };
              }
            }
          });
        }
      });

      let mergedErrors = {
        ...validationErrors,
      };

      if (selectedUserType?.value == 2 || selectedUserType?.value == 3) {
        //2=subcontractor, 3=customer
        mergedErrors.user_documents = {
          ...(additionalErrors?.user_documents || {}),
        };
      }

      if (
        Object.keys(mergedErrors.user_documents || {}).length > 0 ||
        Object.keys(validationErrors || {}).length > 0
      ) {
        setLoadingData(false);
        setFormErrors((prev) => ({
          ...prev,
          ...mergedErrors,
        }));
        return;
      }

      const payload = {
        id: id,
        modelName: initialPayload?.modelName,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        delete formData.inputData.password;
      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
      }

      if (selectedUserType?.value == 1) {
        // User
        delete formData?.inputData?.user_documents;
        payload.inputData = formData?.inputData;
      }

      if (selectedUserType?.value == 2) {
        if (
          Array.isArray(formData?.inputData?.user_documents) &&
          formData?.inputData?.user_documents.length == 0
        ) {
          delete formData?.inputData?.user_documents;
        }

        payload.inputData = formData?.inputData;
        payload.relation = [
          {
            modelName: "user_masters",
            moduleAs: "subcontractor",
            foreignKey: "subcontractor_id",
          },
          {
            modelName: "user_documents",
            moduleAs: "user_documents",
            foreignKey: "user_id",
          },
        ];
      }
      if (selectedUserType?.value == 3) {
        //customer (onyl document)

        if (formData?.inputData?.user_documents.length == 0) {
          delete formData?.inputData?.user_documents;
        }
        payload.inputData = formData?.inputData;
        payload.relation = [
          {
            modelName: "user_documents",
            moduleAs: "user_documents",
            foreignKey: "user_id",
          },
        ];
      }

      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        if (id && userDetails && userDetails.id === parseInt(id)) {
        const updatedUserDetails = {
          ...userDetails,
          first_name: formData.inputData.first_name,
          last_name: formData.inputData.last_name,
          email_id: formData.inputData.email_id,
          mobile_number: formData.inputData.mobile_number,
          role_id: formData.inputData.role_id,
          role_name: selectedRole?.label || userDetails.role_name,
          role_masters: {
            ...(userDetails.role_masters || {}),
            id: formData.inputData.role_id,
            role_name: selectedRole?.label || (userDetails.role_masters || {}),
          }
        };
        localStorage.setItem("userDetails", JSON.stringify(updatedUserDetails));
        
        // Dispatch events to notify other components
        const event = new Event('userDetailsUpdated');
        window.dispatchEvent(event);
      }
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  // add document

  const handleAddUserDocuments = () => {
    const additionalErrors = {};

    const userDocuments = formData?.inputData?.user_documents || [];

    userDocuments.forEach((row, index) => {
      if (row.is_active) {
        ["document", "file"].forEach((field) => {
          if (!row[field]?.toString().trim()) {
            additionalErrors.user_documents = {
              ...additionalErrors.user_documents,
              [index]: {
                ...additionalErrors.user_documents?.[index],
                [field]: `${field
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char) => char.toUpperCase())} is required`,
              },
            };
          }

          if (field === "document" && row[field]) {
            const alphabetError = isAlphabet(row[field], "document");
            if (alphabetError) {
              additionalErrors.user_documents = {
                ...additionalErrors.user_documents,
                [index]: {
                  ...additionalErrors.user_documents?.[index],
                  document: alphabetError,
                },
              };
            }
          }
        });
      }
    });

    if (Object.keys(additionalErrors).length > 0) {
      setFormErrors(additionalErrors);
      return;
    }

    const updatedDocuments = [
      ...userDocuments,
      { document: "", file: null, preview: "", is_active: true },
    ];

    setFormData({
      ...formData,
      inputData: { ...formData.inputData, user_documents: updatedDocuments },
    });
  };

  const handleUserDocumentsOnChange = (e, index) => {
    const { name, value } = e.target;
    const updatedDocuments = [...formData.inputData.user_documents];
    updatedDocuments[index][name] = value;

    // Field-specific validation
    let fieldError = "";

    switch (name) {
      case "document":
        if (!value.trim()) {
          fieldError = "Document is required";
        } else {
          fieldError = isAlphabet(value, name.replace(/_/g, " "));
        }
        break;
      default:
        break;
    }

    // Update form errors
    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      const documentErrors = { ...updatedErrors.user_documents };

      if (!documentErrors[index]) {
        documentErrors[index] = {}; // Initialize the object if it's undefined
      }

      // Update or delete error message for the specific field
      if (fieldError) {
        documentErrors[index][name] = fieldError;
      } else {
        delete documentErrors[index][name]; // Delete error if no error
      }

      // Remove the index if no errors are left for that index
      if (Object.keys(documentErrors[index]).length === 0) {
        delete documentErrors[index];
      }

      // Update the errors object if any documents remain
      if (Object.keys(documentErrors).length > 0) {
        updatedErrors.user_documents = documentErrors;
      } else {
        delete updatedErrors.user_documents;
      }

      return updatedErrors;
    });

    // Update the form data with the new document value
    setFormData({
      ...formData,
      inputData: { ...formData.inputData, user_documents: updatedDocuments },
    });
  };

  const handleFileChange = async (e, index) => {
    const selectedFile = e.target.files[0];
    let errors = {};
    errors.file = selectedFile ? "" : "file is required.";

    if (selectedFile) {
      try {
        setFormErrors((prev) => ({
          ...prev,
          user_documents: {
            ...prev.user_documents,
            [index]: {
              ...prev.user_documents?.[index],
              ...errors,
            },
          },
        }));
        const readFileAsBase64 = (file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
          });
        };

        const base64Data = await readFileAsBase64(selectedFile);
        const response = await uploadFile("uploads", selectedFile);

        if (response?.filePath) {
          // Create a new array to avoid mutating state directly
          const updatedDocuments = formData?.inputData?.user_documents?.map(
            (doc, i) =>
              i === index
                ? {
                    ...doc,
                    file: response?.fileName,
                    preview: base64Data,
                  } // Update the specific index
                : doc
          );

          // Update state immutably
          setFormData((prevState) => ({
            ...prevState,
            inputData: {
              ...prevState.inputData,
              user_documents: updatedDocuments,
            },
          }));
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  };

  const handleRemoveUserDocuments = (index) => {
    const updatedErrors = { ...formErrors };
    delete updatedErrors.user_documents?.[index];

    setFormData((prev) => {
      const updatedDetails = prev.inputData.user_documents.map((doc, i) => {
        if (i === index) {
          return { ...doc, is_active: false };
        }
        return doc;
      });

      return {
        ...prev,
        inputData: {
          ...prev.inputData,
          user_documents: updatedDetails,
        },
      };
    });

    setFormErrors(updatedErrors);
  };

  const handleImageClick = (imageSrc) => {
    window.open(imageSrc, "_blank");
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="User Type"
            value={selectedUserType}
            options={userTypeSelectOptions}
            onSelect={(selected) => handleUserTypeSelect(selected)}
            placeholder="Select User"
            labelClassName="form-label"
            isClearable={false}
            asterisk={true}
            customError={formErrors?.user_type}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Role"
            value={selectedRole}
            options={roleSelectOptions}
            onSelect={(selected) => handleRoleSelect(selected)}
            placeholder="Select Role"
            labelClassName="form-label"
            isClearable={false}
            asterisk={true}
            customError={formErrors?.role_id}
          />
        </Col>

        <Col md="6" className="mt-3">
          <SelectInput
            label="Company"
            value={
              selectedUserType?.value === 1
                ? companySelectOptions[0]?.options[0]
                : selectedCompany
            }
            options={companySelectOptions}
            onSelect={(selected) => handleCompanySelect(selected)}
            placeholder="Select Company"
            labelClassName="form-label"
            isClearable={false}
            asterisk={true}
            customError={formErrors?.company_id}
            disabled={selectedUserType?.value === 1 ? true : false}
          />
        </Col>

        <Col md="6" className="mt-3">
          <TextInput
            label="First Name"
            name="first_name"
            value={formData?.inputData?.first_name}
            onChange={onInputChange}
            placeholder="First Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.first_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Last Name"
            name="last_name"
            value={formData?.inputData?.last_name}
            onChange={onInputChange}
            placeholder="Last Name"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.last_name}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Email"
            name="email_id"
            value={formData?.inputData?.email_id}
            onChange={onInputChange}
            placeholder="Email"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.email_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Password"
            name="password"
            value={formData?.inputData?.password}
            onChange={onInputChange}
            placeholder="Password"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.password}
            type={isPasswordShown ? "password" : "text"}
            disabled={id ? true : false}
          />
        </Col>
        <Col md="6" className="mt-3">
          <TextInput
            label="Mobile Number"
            name="mobile_number"
            value={formData?.inputData?.mobile_number}
            onChange={onInputChange}
            placeholder="Mobile Number"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.mobile_number}
          />
        </Col>

        {selectedUserType && selectedUserType?.value !== 1 && (
          <Col md="6" className="mt-3">
            <TextInput
              label="Alternative Mobile Number"
              name="alt_mobile_number"
              value={formData?.inputData?.alt_mobile_number}
              onChange={onInputChange}
              placeholder="Alternative mobile number"
              inputClassName="form-control"
              labelClassName="form-label"
              customError={formErrors?.alt_mobile_number}
            />
          </Col>
        )}

        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Address"
            name="address"
            value={formData?.inputData?.address}
            onChange={onInputChange}
            placeholder="Address"
            inputClassName="form-control"
            labelClassName="form-label"
            customError={formErrors?.address}
          />
        </Col>
      </Row>

      {/* Add documents */}
      {selectedUserType &&
        (selectedUserType?.value == 2 || selectedUserType?.value == 3) && (
          <Row className="mt-4">
            <Col
              style={{
                marginLeft: "",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBlock: "5px",
                gap: "1rem",
              }}
            >
              <div>
                <h6 className="h-6-heading m-0">Attachments</h6>
              </div>
              <Button
                color="primary"
                className="waves-effect waves-light me-1"
                onClick={handleAddUserDocuments}
                style={{ background: "#006eb9" }}
              >
                Add
              </Button>
            </Col>
            <div
              className="table mt-2"
              style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "500px",
                width: "100%",
                scrollBehavior: "smooth",
                scrollbarWidth: "thin",
                msOverflowStyle: "none",
                zIndex: 0,
              }}
            >
              {" "}
              <table className="table table-hover">
                <thead
                  style={{
                    backgroundColor: "#8AC1E8",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#8AC1E8",
                    borderBottom: "1px solid black",
                    zIndex: 1,
                  }}
                >
                  <tr style={{ borderBottom: "1px solid black" }}>
                    <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Document <Asterisks asterisk={true} />
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      File <Asterisks asterisk={true} />
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Preview</th>
                    <th style={{ whiteSpace: "nowrap" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {formData?.inputData &&
                    formData?.inputData?.user_documents &&
                    formData?.inputData?.user_documents
                      .map((item, originalIndex) => ({
                        ...item,
                        originalIndex,
                      }))
                      .filter((item) => item.is_active)
                      .map((item, filteredIndex) => (
                        <React.Fragment key={item.originalIndex}>
                          <tr
                            style={{
                              borderBottom: "1px solid #cccccc",
                              verticalAlign: "middle",
                            }}
                          >
                            <td>{filteredIndex + 1}</td>
                            <td>
                              <TextInput
                                name="document"
                                value={item.document}
                                onChange={(e) =>
                                  handleUserDocumentsOnChange(
                                    e,
                                    item.originalIndex
                                  )
                                }
                                placeholder="Document"
                                inputClassName="form-control"
                                labelClassName="form-label"
                                labelStyle={{ display: "none" }}
                                asterisk={true}
                                customError={
                                  formErrors?.user_documents?.[
                                    item.originalIndex
                                  ]?.document || ""
                                }
                              />
                            </td>
                            <td>
                              <div style={{ position: "relative" }}>
                                <input
                                  name="file"
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleFileChange(e, item.originalIndex)
                                  }
                                  className="form-control"
                                  style={{
                                    border:
                                      formErrors?.user_documents?.[
                                        item.originalIndex
                                      ]?.file && "1px solid red",
                                    borderColor:
                                      formErrors?.user_documents?.[
                                        item.originalIndex
                                      ]?.file && "#d15757",
                                    boxShadow:
                                      formErrors?.user_documents?.[
                                        item.originalIndex
                                      ]?.file &&
                                      "0px 0px 3px rgba(255, 0, 0, 0.5)",
                                  }}
                                />
                                {formErrors?.user_documents?.[
                                  item.originalIndex
                                ]?.file && (
                                  <i
                                    className="fas fa-exclamation-circle"
                                    style={{
                                      position: "absolute",
                                      top: "50%",
                                      right: "10px",
                                      transform: "translateY(-50%)",
                                      color: "#d15757",
                                    }}
                                  ></i>
                                )}
                              </div>
                              {formErrors?.user_documents?.[item.originalIndex]
                                ?.file && (
                                <CustomError
                                  error={
                                    formErrors?.user_documents?.[
                                      item.originalIndex
                                    ]?.file || ""
                                  }
                                />
                              )}
                            </td>
                            <td>
                              {item?.preview ? (
                                <img
                                  onClick={() =>
                                    handleImageClick(imageURL + item?.file)
                                  }
                                  src={item?.preview}
                                  alt="Preview"
                                  style={{ width: "100px", height: "100px" }}
                                  onError={(e) =>
                                    (e.target.src = "/placeholder.png")
                                  }
                                />
                              ) : item?.file ? (
                                <img
                                  src={imageURL + item?.file}
                                  onClick={() =>
                                    handleImageClick(imageURL + item?.file)
                                  }
                                  alt="Preview"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    cursor: "pointer",
                                  }}
                                  onError={(e) =>
                                    (e.target.src = "/placeholder.png")
                                  }
                                />
                              ) : (
                                <span>Preview</span>
                              )}
                            </td>

                            <td>
                              <div
                                onClick={() =>
                                  handleRemoveUserDocuments(item.originalIndex)
                                }
                              >
                                <Link className="text-danger">
                                  <i className="mdi mdi-trash-can font-size-20"></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                </tbody>
              </table>
            </div>
          </Row>
        )}
      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
    </CustomForm>
  );
};

export default UserCreate;
